import React, { useState } from 'react';

function SurveyStepEight({ formData, onNext }) {
    const [learningOpportunity, setLearningOpportunity] = useState(formData.learningOpportunity || '');
    const [learningComments, setLearningComments] = useState(formData.learningComments || '');
    const [error, setError] = useState('');

    const handleContinue = () => {
        if (!learningOpportunity) {
            setError('Please select a rating.');
            return;
        }
        setError('');
        onNext({ learningOpportunity, learningComments });
    };

    const ratingOptions = ['N/A', ...Array.from({ length: 10 }, (_, i) => (i + 1).toString())];

    return (
        <div className="step-form">
            <h6 className="mb-4">Section 2: Career Development</h6>

            {error && <div className="alert alert-danger">{error}</div>}

            <label className="form-label">
                How sufficient are the opportunities you are given to learn and develop your skills at work? <span className="text-danger">*</span>
            </label>

            <div className="d-flex flex-wrap gap-2 mb-4 justify-content-around">
                {ratingOptions.map((option) => (
                    <div key={option} className="form-check rating_btn">
                        <input
                            type="radio"
                            id={`learning-opportunity-${option}`}
                            name="learningOpportunity"
                            value={option}
                            checked={learningOpportunity === option}
                            onChange={() => setLearningOpportunity(option)}
                        />
                        <label htmlFor={`learning-opportunity-${option}`}>{option}</label>
                    </div>
                ))}
            </div>

            <div className="mb-3">
                <label className="form-label">Additional comments (optional):</label>
                <textarea
                    className="form-control"
                    rows="4"
                    value={learningComments}
                    onChange={(e) => setLearningComments(e.target.value)}
                    placeholder="Share any additional thoughts here..."
                />
            </div>

            <div className="text-end mt-5">
                <button
                    className="btn btn-dark px-4"
                    onClick={handleContinue}
                    disabled={!learningOpportunity}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default SurveyStepEight;
